import { BaseResponse } from '../../../../../../types/api/api.types';
import {
  CompanyRequestData,
  RegisterCompanyStepResponse,
} from '../../../../../../types/api/endpoints/auth/register.types';
import { AUTH_ENDPOINTS } from '../../../../../../utils/api/endpoints/authEndpoints';
import { RegisterCompanyStepFormSchema } from './RegisterCompanyStepForm.types';

const PREFIX = '[registerCompagnQuery]';

export const REGISTER_SIGN_UP_QUERY_KEY = 'REGISTER_SIGN_UP';

export const registerCompagnyQuery = async (data: RegisterCompanyStepFormSchema) => {
  console.log(PREFIX, `Requesting user account creation...`);

  const updatedData = Object.keys(data).reduce((acc, key) => {
    const value = data[key as keyof typeof data];

    if (value) {
      return {
        ...acc,
        [key]: value,
      };
    } else {
      return {
        ...acc,
        [key]: null,
      };
    }
  }, {} as CompanyRequestData);

  const response = await AUTH_ENDPOINTS.company(updatedData);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received user account creation.`);
  return json as RegisterCompanyStepResponse;
};

const LOGO_PREFIX = '[registerDocumentQuery]';

export const UPLOAD_LOGO_ENT_QUERY_KEY = 'UPLOAD_LOGO_ENT';

export const queryUploadLogo = async (data: FormData) => {
  console.log(LOGO_PREFIX, `Requesting logo uploading...`);

  const response = await AUTH_ENDPOINTS.logoENT(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(LOGO_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(LOGO_PREFIX, `Received logo.`);
  return json as BaseResponse;
};

const REMOVE_LOGO_PREFIX = '[registerDocumentQuery]';

export const REMOVE_LOGO_ENT_QUERY_KEY = 'REMOVE_LOGO_ENT';

export const queryRemoveLogo = async () => {
  console.log(REMOVE_LOGO_PREFIX, `Requesting logo removing...`);

  const response = await AUTH_ENDPOINTS.removeLogoENT();

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(REMOVE_LOGO_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(REMOVE_LOGO_PREFIX, `Received logo.`);
  return json as BaseResponse;
};
